import Vue from 'vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.use(Loading as any);

export class LoaderService {
  private loader: any;
  private count = 0;
  private delay: any;

  public start() {
    if (!this.loader && !this.delay) {
      this.delay = setTimeout(() => (this.loader = (Vue as any).$loading.show({})), 200);
    }
    this.count++;
  }

  public end() {
    if (this.delay || this.loader) {
      this.count--;
    }
    if (this.delay && this.count === 0) {
      clearTimeout(this.delay);
      this.delay = null;
    }
    if (this.loader && this.count === 0) {
      this.loader.hide();
      this.loader = undefined;
    }
  }
}

export default new LoaderService();
